import { Textarea, TextInput, Modal, Button } from "@mantine/core";
import ImageUploader from "./ImageUploader";
// import urlToHttp from '../utils/urlToHttp';
import { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { usePinata } from "../hooks/usePinata";
import { useEthers } from "@usedapp/core";
import { useUpdateCampaign } from "../hooks/useUpdateCampaign";
import { useState, useRef } from "react";
import LoadingModal from "./LoadingModal";
const EditCampaignModal = ({
  opened,
  setOpened,
  baseInfo,
  campaignAddrArray,
  expectedChain,
  campaignType,
}) => {
  // const [closeListener, setCloseListener] = useState(false);
  const [loadingPrompt, setLoadingPrompt] = useState("");
  // const [visible, setVisible] = useState(false);
  const [loadingModalOpened, setLoadingModalOpened] = useState(false);
  const modal = useRef(null);
  const { chainId, switchNetwork } = useEthers();
  // eslint-disable-next-line
  const { uploadEditForm } = usePinata();
  const FILE_SIZE = 35 * 1024 * 1024;
  const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/jpeg",
    "image/gif",
    "image/png",
  ];
  const [frozenModal, setFrozenModal] = useState(true);
  // const [successUpdate, setSuccessUpdate] = useState(false);
  // const [interruptedUpdate, setInterruptedUpdate] = useState(false);
  const formSchema = Yup.object({
    thumbnail: Yup.mixed()
      .required("Image is required")
      .test("fileSize", "File too large", (value) => {
        if (typeof value === "string") {
          return true;
        } else {
          return value && value.size <= FILE_SIZE;
        }
      })
      .test("fileFormat", "Unsupported Format", (value) => {
        if (typeof value === "string") {
          return true;
        } else {
          return value && SUPPORTED_FORMATS.includes(value.type);
        }
      }),
    description: Yup.string().required(),
    twitter_url: Yup.string().url("Please enter a valid url"),
    discord_url: Yup.string().url("Please enter a valid url"),
    website_url: Yup.string()
      .url("Please enter a valid url")
      .required("Website url is required"),
    opensea_url: Yup.string().url("Please enter a valid url"),
  });
  const info = {
    description: "",
    twitter_url: "",
    discord_url: "",
    website_url: "",
    opensea_url: "",
    thumbnail: "",
  };
  // eslint-disable-next-line
  const campaignAddr = campaignAddrArray[0];
  // eslint-disable-next-line
  const [updateBaseInfoURI, updateState] = useUpdateCampaign(
    campaignAddr,
    campaignType
  );
  useEffect(() => {
    if (updateState.status === "Exception") {
      setLoadingPrompt("Error");
    }
    if (updateState.status === "Success") {
      setLoadingPrompt("Success");
    }
    if (updateState.status === "Mining") {
      setLoadingPrompt("Updating...");
    }
    //eslint-disable-next-line
  }, [updateState.status]);

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: baseInfo ? baseInfo : info,
    validationSchema: formSchema,
    onSubmit: async (values, actions) => {
      if (Object.keys(formik.errors).length !== 0) {
        actions.setSubmitting(false);
      } else {
        // setSuccessUpdate(false);
        // setInterruptedUpdate(false);
        // setVisible(true);
        setFrozenModal(false);
        //   modal.current.modal.closeOnclickOutside = false;
        const EditCampaignForm = {
          description: formik.values.description,
          twitter_url: formik.values.twitter_url,
          discord_url: formik.values.discord_url,
          website_url: formik.values.website_url,
          opensea_url: formik.values.opensea_url,
          thumbnail: formik.values.thumbnail,
        };

        try {
          setLoadingPrompt("Uploading Base Info...");
          const [baseHash] = await uploadEditForm(EditCampaignForm);
          setLoadingPrompt("Waiting for confirmation...");
          await updateBaseInfoURI(baseHash);
          setLoadingPrompt("Done Confirming");
        } catch (err) {
          console.log("Error: here is the error");
          console.log(err);
        }
        setFrozenModal(true);
        // setVisible(false);
      }
    },
  });
  useEffect(() => {
    formik.setFieldValue("description", baseInfo.description);
    formik.setFieldValue("twitter_url", baseInfo.twitter_url);
    formik.setFieldValue("thumbnail", baseInfo?.image_hash ?? baseInfo?.image);
    formik.setFieldValue("website_url", baseInfo.website_url);
    formik.setFieldValue("discord_url", baseInfo.discord_url);
    formik.setFieldValue("opensea_url", baseInfo.opensea_url);
  }, [baseInfo]); // eslint-disable-line

  const switchNet = () => {
    switchNetwork(expectedChain?.chainId);
  };
  const initOverLay = async () => {
    if (Object.keys(formik.errors).length !== 0) {
      console.log("errors", formik.errors);
    } else {
      setLoadingModalOpened(true);
      // setVisible(true);
    }
  };
  const closeModal = () => {
    // setSuccessUpdate(false);
    // setInterruptedUpdate(false);
    setOpened(false);
  };
  return (
    <Modal
      ref={modal}
      opened={opened}
      closeOnClickOutside={frozenModal}
      id="edit-campaign-modal"
      title="Edit Campaign Details"
      onClose={closeModal}
    >
      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        <label className="label-form">
          <p>Description</p>
          <p className="ml-1 text-warning">*</p>
        </label>
        <Textarea
          classNames={{
            label: "label-form",
            input:
              formik.errors.description && formik.touched.description
                ? "input-pri-error h-36"
                : "input-pri h-36",
            root: "mb-6",
          }}
          id="description"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.description}
          error={
            formik.errors.description && formik.touched.description
              ? "Description is required"
              : ""
          }
          required
        />
        <ImageUploader formik={formik} />
        <TextInput
          classNames={{
            label: "label-form",
            input:
              formik.errors.website_url && formik.touched.website_url
                ? "input-pri-error"
                : "input-pri",
            root: "mb-6",
          }}
          label="Website"
          id="website_url"
          type="link"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.website_url}
          error={
            formik.errors.website_url && formik.touched.website_url
              ? formik.errors.website_url
              : ""
          }
          required
        />
        <div>
          <label className="label-form">Discord</label>
          <TextInput
            classNames={{
              label: "label-form",
              input:
                formik.errors.discord_url && formik.touched.discord_url
                  ? "input-pri-error"
                  : "input-pri",
              root: "mb-6",
            }}
            id="discord_url"
            type="link"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.discord_url}
            error={
              formik.errors.discord_url && formik.touched.discord_url
                ? formik.errors.discord_url
                : ""
            }
          />
        </div>
        <div>
          <label className="label-form">Twitter</label>
          <TextInput
            classNames={{
              label: "label-form",
              input:
                formik.errors.twitter_url && formik.touched.twitter_url
                  ? "input-pri-error"
                  : "input-pri",
              root: "mb-6",
            }}
            id="twitter_url"
            type="link"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.twitter_url}
            error={
              formik.errors.twitter_url && formik.touched.twitter_url
                ? formik.errors.twitter_url
                : ""
            }
          />
        </div>
        <div>
          <label className="label-form">Opensea</label>
          <TextInput
            classNames={{
              label: "label-form",
              input:
                formik.errors.opensea_url && formik.touched.opensea_url
                  ? "input-pri-error"
                  : "input-pri",
              root: "mb-6",
            }}
            id="opensea_url"
            type="link"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.opensea_url}
            error={
              formik.errors.opensea_url && formik.touched.opensea_url
                ? formik.errors.opensea_url
                : ""
            }
          />
        </div>
        {chainId !== expectedChain?.chainId ? (
          <Button className="btn-pri mt-10 mb-10 px-12" onClick={switchNet}>
            Switch to {expectedChain?.chainName} Network
          </Button>
        ) : (
          // () => setVisible((v) => !v)
          <Button
            className="btn-pri mt-10 mb-10 px-12"
            type="submit"
            onClick={initOverLay}
          >
            Save
          </Button>
        )}
        {/* <div>
          {successUpdate && (
            <div className=" text-green-400">
              <p>Campaign Updated Successfully</p>
            </div>
          )}
        </div>
        <div>
          {interruptedUpdate && (
            <div className=" text-red-400">
              <p>Campaign Updated Unsuccessfully</p>
            </div>
          )}
        </div> */}
      </form>
      <LoadingModal
        loadingOpen={loadingModalOpened}
        setLoadingOpen={setLoadingModalOpened}
        setLoadingPrompt={setLoadingPrompt}
        loadingPrompt={loadingPrompt}
        setOpened={setOpened}
      ></LoadingModal>
    </Modal>
  );
};

export default EditCampaignModal;
